import { render, staticRenderFns } from "./OtherConnectorCard.vue?vue&type=template&id=2359e036&scoped=true"
import script from "./OtherConnectorCard.vue?vue&type=script&lang=js"
export * from "./OtherConnectorCard.vue?vue&type=script&lang=js"
import style0 from "./OtherConnectorCard.vue?vue&type=style&index=0&id=2359e036&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2359e036",
  null
  
)

export default component.exports